// extracted by mini-css-extract-plugin
module.exports = {"list":"ListComponentPromo_list__zJnTw"};